import React from "react"
import Button from "@kit/design/button"
import { analytics } from "utils/analytics"

const trackClick = () => {
  analytics.track(
    "Element",
    "Clicked",
    {
      name: "header_upgrade_now",
      text: "Upgrade now"
    },
    { transport: "beacon" }
  )
}

export function TrialNav({ userInfo, daysLeft }) {
  const showCountdown = userInfo.trialing
  const showUpgradeButton = userInfo.trialing

  return (
    <React.Fragment>
      <div className="flex items-center">
        {showCountdown && (
          <div className="my-auto mx-5 text-black">
            Trial: {daysLeft} remaining
          </div>
        )}

        {showUpgradeButton && (
          <Button is="primary" size="sm" href="/upgrade" onClick={trackClick}>
            Upgrade
          </Button>
        )}
      </div>
    </React.Fragment>
  )
}
